import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "subcatalogue" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SubCatalogueGrid = _resolveComponent("SubCatalogueGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SubCatalogueGrid, {
      parentModel: _ctx.parentModel,
      controller: 'DCatalogueItem',
      columns: _ctx.columns,
      filterRowVisible: true,
      groupPanelVisible: false,
      headerFilterVisible: true,
      editingConfig: _ctx.editingConfig,
      selectionConfig: _ctx.selectionConfig,
      designConfig: _ctx.designConfig,
      popupCreateEditComponent: _ctx.dCatalogueItemCreateEditDialog
    }, null, 8, ["parentModel", "columns", "editingConfig", "selectionConfig", "designConfig", "popupCreateEditComponent"])
  ]))
}